import { useAuth } from "../../context/AuthContext";
import MyAttendancePage from "./MyAttendancePage";
import TeamAttendancePage from "./TeamAttendancePage";
import AllAttendancePage from "./AllAttendancePage";

export default function AttendanceRouter() {
  const { user } = useAuth();
  const role = user?.role;
  if (role === "sales_officer") return <MyAttendancePage />;
  if (role === "assistant_manager" || role === "admin_manager") return <TeamAttendancePage />;
  return <AllAttendancePage />;
}
